import { Divider, Modal, Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { PendingSpinner } from '@/core/components';

import { getUserDocumentUserOptions } from '../model/UserDocumentQuery';
import { userDocumentKindList } from '../model/UserDocumentTypes';
import { UserDocumentAdminSlotRow } from './UserDocumentAdminSlotRow';

interface UserDocumentUserPanelProps {
  userId: number;
  userName: string;
  onClose: () => void;
}

export function UserDocumentUserPanel({ userId, userName, onClose }: UserDocumentUserPanelProps) {
  const { t } = useTranslation();
  const { data, isPending, isError } = useQuery(getUserDocumentUserOptions(userId));

  const uploadedCount = data?.slots.filter(slot => slot.document != null).length ?? 0;

  return (
    <Modal
      opened
      centered
      onClose={onClose}
      title={userName}
      size="xl"
    >
      <Stack gap="4px">
        {isPending && <PendingSpinner h="120px" />}
        {isError && data == null && (
          <Text
            c="dimmed"
            size="sm"
            fs="italic"
          >
            {t('userDocuments.loadError')}
          </Text>
        )}
        {data != null && (
          <>
            <Text
              c="dimmed"
              size="sm"
              fs="italic"
            >
              {t('userDocuments.completeness', { uploaded: uploadedCount, total: userDocumentKindList.length })}
            </Text>
            <Stack
              gap="sm"
              mt="md"
            >
              {data.slots.map((slot, index) => (
                <Fragment key={slot.kind}>
                  {index > 0 && <Divider />}
                  <UserDocumentAdminSlotRow
                    userId={userId}
                    slot={slot}
                  />
                </Fragment>
              ))}
            </Stack>
          </>
        )}
      </Stack>
    </Modal>
  );
}
